/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function useLoadGoogleMaps(): boolean {
  const [loaded, setLoaded] = useState(false);
  const { t } = useTranslation(['googleMap']);

  useEffect(() => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const id = 'googleMaps';

    if (!apiKey) {
      console.error(t('googleMap:googleMapApiKeyMissing'));
      return;
    }

    if ((window as any).google?.maps?.places) {
      setLoaded(true);
      return;
    }

    const existingScript = document.getElementById(id);
    if (existingScript) return;

    const script = document.createElement('script');
    script.id = id;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      setLoaded(true);
    };

    script.onerror = () => {
      console.error(t('googleMap:failedToLoadScript'));
    };

    document.body.appendChild(script);
  }, []);

  return loaded;
}
